<template>
  <div>
    <div class="uk-width-large uk-margin-auto">
      <div class="uk-card uk-card-default">
        <div class="uk-card-header">
          <div class="uk-grid-small uk-flex-middle" uk-grid>
            <div class="uk-width-expand">
              <h3 class="uk-card-title uk-margin-remove-bottom uk-text-center">
                <template v-if="type === 'new'">Payment Details</template>
                <template v-if="type === 'update'">Update Payment Details</template>
              </h3>
            </div>
          </div>
        </div>

        <div class="uk-card-body">
          <div ref="card" data-cy="stripe" />
          <div class="card-error" :class="{'active': error.card }">{{ error.card }}</div>
        </div>

        <div class="uk-card-footer uk-text-center">
          <button class="uk-button uk-button-primary" :disabled="!submit || error.card || error.script" data-cy="submit" @click="handlePayment">Proccess Payment</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ComponentAppointmentPayment',

  props: {
    appointment: {
      type: String,
      required: true
    },
    secret: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        // The value must match one of these strings
        return ['new', 'update'].indexOf(value) !== -1
      }
    }
  },

  data() {
    return {
      submit: false,
      stripe: null,
      card: null,
      error: {
        script: false,
        card: null,
        stripe: false
      },
      style: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
    }
  },

  mounted() {
    this.stripe = Stripe(this.$globals.stripe.key) // eslint-disable-line
    const elements = this.stripe.elements()
    this.card = elements.create('card', { style: this.style })
    this.card.mount(this.$refs.card)
    this.card.on('change', this.cardValidation)
  },

  methods: {
    cardValidation(event) {
      if (event.error) {
        this.error.card = event.error.message
      } else {
        this.error.card = null
      }

      this.submit = event.complete
    },

    async handlePayment() {
      const loader = this.$loader.show('Processing Payment - Stripe')

      try {
        const payment = await this.stripe.confirmCardPayment(this.secret, {
          payment_method: { card: this.card }
        })

        loader.setText('Storing Payment Data')

        const log = {
          timestamp: this.$firebase.firestore.Timestamp.now(),
          user: this.$store.state.account.record.uid,
          type: 'update',
          subtype: 'appointment-payment',
          content: {
            status: payment.paymentIntent.status
          }
        }

        await this.$firebase.firestore().collection(this.$globals.firebase.collection.appointments).doc(this.appointment).update({
          'payment.status': payment.paymentIntent.status,
          log: this.$firebase.firestore.FieldValue.arrayUnion(log)
        })

        await loader.hide()

        this.$bus.$emit('appointment-section-complete', { type: 'payment', data: payment })
      } catch (error) {
        this.error.stripe = true
        loader.hide(true)
        this.$bus.$emit('appointment-error', { type: 'payment-error', message: error.message, status: 'danger' })
      }
    }
  }
}
</script>

<style lang="scss">
.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  transition: box-shadow 150ms ease;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: $colour-danger;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.card-error {
  margin-top: 4px;
  padding: 2px 4px;
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 200ms ease;
  background-color: $colour-danger;
  color: $colour-light;
  text-align: center;

  &.active {
    transform: scaleY(1);
  }
}
</style>
